import React from 'react';
import ProjectsMain from '../ProjectsMain/ProjectsMain';

const Projects = () => {
    return (
        <div>
           <ProjectsMain /> 
        </div>
    );
};

export default Projects;